
import ko from 'rgs-knockout';

const $ = require('jquery');


const bindingProvider = ko.bindingProvider.instance;


ko.bindingHandlers['ko-component-btn-radio-group#clickListener'] = {
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		
		const clickCallback = e => {
			const { currentTarget } = e;
			const ctx = ko.contextFor(currentTarget);
			const bindingAccessors = ctx && bindingProvider.getBindingAccessors(currentTarget, ctx);
			const btnValueAccessor = bindingAccessors && bindingAccessors['btnRadioGroupValue'];
			bindingContext.$component._value(btnValueAccessor());
		};

		$(element)
			.on('click', '.btn', clickCallback)
			.on('click', '.btn-special', clickCallback);
	},
};

ko.bindingHandlers.btnRadioGroupValue = {
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		ko.applyBindingAccessorsToNode(element, {
			css: function () {
				return {
					active: bindingContext.$component._value() === valueAccessor(),
				};
			},
		}, bindingContext);
	},
};
